import { render, staticRenderFns } from "./sysdic.vue?vue&type=template&id=a152bbf8"
import script from "./sysdic.vue?vue&type=script&lang=js"
export * from "./sysdic.vue?vue&type=script&lang=js"
import style0 from "./sysdic.vue?vue&type=style&index=0&id=a152bbf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports